module.exports = __webpack_public_path__ + "resources/img/img_datahunt1_m_en.3b5d14fbaf105e693460b798746841c1.png";